import apiManager from './apiManager'
const listAdminRoles = async () => {
	const adminRoles = apiManager.axios
		.get(`/v1/owner/admin`)
		.then((response) => {
			return { status: 200, data: response.data }
		})
		.catch((err) => {
			return {
				status: err.response.status,
			}
		})

	return adminRoles
}

const listRoles = async () => {
	const roles = apiManager.axios
		.get(`/v1/owner/role/listRoles`)
		.then((response) => {
			return { status: 200, data: response.data }
		})
		.catch((err) => {
			return {
				status: err.response.status,
			}
		})

	return roles
}

const createNewAccount = async (queryObj) => {
	const accountCreate = apiManager.axios
		.post(`/v1/owner/admin`, {
			email: queryObj.email,
			firstName: queryObj.firstName,
			lastName: queryObj.lastName,
			password: queryObj.password,
			phone: queryObj.phone,
			roleId: queryObj.roleId,
			specialization: queryObj.specialization,
			active: queryObj.active,
		})
		.then((response) => {
			return response
		})
		.catch((err) => {
			console.error(err)
			return {
				status: err.response.status,
			}
		})

	return accountCreate
}

const deletePersonnelAccount = async (id) => {
	const deleteAccount = apiManager.axios
		.delete(`v1/owner/admin/${id}`)
		.then((response) => {
			return response
		})
		.catch((err) => {
			console.error(err)
			return {
				status: err.response.status,
			}
		})
	return deleteAccount
}

const editPersonnelAccount = async (id, queryObj) => {
	const dataWithPassword = {
		email: queryObj.email,
		firstName: queryObj.firstName,
		lastName: queryObj.lastName,
		phone: queryObj.phone,
		roleId: queryObj.roleId,
		specialization: queryObj.specialization,
		active: queryObj.active,
	}
	if (queryObj.password != '') {
		const editAccount = apiManager.axios
			.patch(`v1/owner/admin/${id}`, {
				...queryObj,
			})
			.then((response) => {
				return response
			})
			.catch((err) => {
				console.error(err)
				return {
					status: err.response.status,
				}
			})
		return editAccount
	} else {
		const editAccount = apiManager.axios
			.patch(`v1/owner/admin/${id}`, {
				...dataWithPassword,
			})
			.then((response) => {
				return response
			})
			.catch((err) => {
				console.error(err)
				return {
					status: err.response.status,
				}
			})
		return editAccount
	}
}

export default {
	listAdminRoles,
	listRoles,
	createNewAccount,
	deletePersonnelAccount,
	editPersonnelAccount,
}
